import ErrorStackParser from 'error-stack-parser';
import { getTimestamp, resourceTransform, unknownToString } from '../utils/unils.js';

const handleJsError = ev => {
    var _a;
    const target = ev.target;
    if (!target || (ev.target && !((_a = ev.target) === null || _a === void 0 ? void 0 : _a.localName))) {
        // 获取原始堆栈至多5条信息
        let stackOrgArr = ErrorStackParser.parse(!target ? ev : ev.error).slice(0, 5);
        let starkArr = [];
        stackOrgArr.forEach(item => {
            let { source } = item;
            const stack = source ? source.split(' ').join('').split('./') : '';
            starkArr.push(stack);
        });
        // vue和react捕获的报错使用ev解析，异步错误使用ev.error解析
        // 具体原因解析
        let stackFrame = ErrorStackParser.parse(!target ? ev : ev.error)[0];
        let { fileName, columnNumber, lineNumber } = stackFrame;
        let errorData = {
            type: 'error',
            time: getTimestamp(),
            message: ev.message,
            fileName,
            line: lineNumber,
            column: columnNumber,
            stack: JSON.stringify(starkArr)
        };
        return errorData;
    }
    else {
        return null;
    }
};
const handleResourceError = ev => {
    const target = ev.target;
    if (target === null || target === void 0 ? void 0 : target.localName) {
        const errorData = resourceTransform(target);
        return Object.assign(Object.assign({}, errorData), { type: 'resourceError' });
    }
    else {
        return null;
    }
};
const handlerRejection = ev => {
    // 获取原始堆栈至多5条信息
    let stackOrgArr = ErrorStackParser.parse(ev.reason).slice(0, 5);
    let starkArr = [];
    stackOrgArr.forEach(item => {
        let { source } = item;
        const stack = source ? source.split(' ').join('').split('./') : '';
        starkArr.push(stack);
    });
    // 具体原因解析
    let stackFrame = ErrorStackParser.parse(ev.reason)[0];
    let { fileName, columnNumber, lineNumber } = stackFrame;
    let data = {
        type: 'rejectionError',
        time: getTimestamp(),
        message: unknownToString(ev.reason.message || ev.reason.stack),
        fileName,
        line: lineNumber,
        column: columnNumber,
        stack: JSON.stringify(starkArr)
    };
    return data;
};

export { handleJsError, handleResourceError, handlerRejection };
